import { navLinks } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr] gap-8 md:gap-12">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-sun-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-semibold tracking-wide">长日光阴</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200">
              一个记录情感故事与岁月往事的角落。写旧物、写家人、写故乡，也写那些说不出口的碎碎念。
              愿每一个怀念过去的人，都能在这里被温柔地读到。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm tracking-widest text-background-300 uppercase">
              浏览分区
            </h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-background-100 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm tracking-widest text-background-300 uppercase">
              我们记录的主题
            </h3>
            <ul className="mt-4 flex flex-wrap gap-2 text-xs">
              {["情感故事", "回忆录", "旧时光", "岁月故事", "时光往事", "情感共鸣"].map((tag) => (
                <li
                  key={tag}
                  className="px-2.5 py-1 rounded-full bg-secondary-900 text-background-200"
                >
                  {tag}
                </li>
              ))}
            </ul>
            <a
              href="#subscribe"
              className="mt-5 inline-flex items-center gap-2 text-sm text-primary-300 hover:text-primary-200 transition-colors cursor-pointer"
            >
              <i className="ri-mail-send-line"></i>
              订阅回忆录
            </a>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-background-300">
          <p>© {new Date().getFullYear()} 长日光阴 · 旧时光里的岁月往事，值得细品的情感记忆</p>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 hover:text-primary-300 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-up-line"></i>
            回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}